import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import React from "react";

const paymentFlowSearchSchema = z.object({
  backUrl: z.string().optional(),
  source: z.string().optional(),
});

export const Route = createFileRoute("/paymentFlow/$programId")({
  component: React.lazy(() =>
    import("@/pages/paymentFlow/").then((mod) => ({
      default: mod.PaymentFlow,
    })),
  ),
  validateSearch: (search) => paymentFlowSearchSchema.parse(search),
});
